import { useSyncExternalStore } from 'react';
import { optimisticVersion, subscribeOptimistic } from '../services/optimistic';

/** Re-renders when an optimistic patch is laid or cleared (services/optimistic, speed.md 2). */
export function useOptimisticVersion(): number {
  return useSyncExternalStore(subscribeOptimistic, optimisticVersion, optimisticVersion);
}
